module.exports = __webpack_public_path__ + "img/rotate.489e094a.svg";